import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import {Tooltip} from "@mui/material";
import DoneAllIcon from '@mui/icons-material/DoneAll';

function VerifiedSkill(props: Props) {
  return (
    <Tooltip title={'Go to certificate'} placement={'top'}>
      <a href={props.certificateUrl} className={'verified-skill'} target={'_blank'} rel={'noreferrer'}>
        <LocalPoliceIcon color={'inherit'}/>
        <div className={'skill-name'}>{props.skillName}</div>
        <div className={'verified-unit'}><DoneAllIcon fontSize={'inherit'} color={'inherit'}/>Verified</div>
      </a>
    </Tooltip>
  )
}

export default VerifiedSkill;

class Props {
  certificateUrl: string;
  skillName: string;
}